import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { expVal } from '@atlassian/jira-feature-experiments';
import parameters from './__generated__/MoreProjectsQuery.graphql';
import type { ExtraProps } from './types.tsx';

type EntryPointParams = { cloudId: string; currentURL: string } & ExtraProps;
export const MoreProjectsEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-more-projects-flyout" */ './MoreProjects.tsx').then(
			({ MoreProjects }) => MoreProjects,
		),
	),
	getPreloadProps: ({ cloudId, currentURL }: EntryPointParams) => ({
		queries: {
			moreProjects: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					cloudId,
					currentURL,
					isProjectsSearchInSidebarEnabled: expVal(
						'blu-7465-projects-search-in-sidebar',
						'isEnabled',
						false,
					),
				},
			},
		},
		extraProps: {},
	}),
});
